import { render } from "./InviteModal.vue?vue&type=template&id=dd3424cc"
import script from "./InviteModal.vue?vue&type=script&lang=js"
export * from "./InviteModal.vue?vue&type=script&lang=js"

import "./InviteModal.vue?vue&type=style&index=0&id=dd3424cc&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__